export type UseFormBackupProps = {
  uid: string
}

export type UseFormBackupReturn<T> = {
  clearBackup: () => void
  backup: (values: T) => void
  initialValues?: T
}

export const useFormBackup = <T>({ uid }: UseFormBackupProps): UseFormBackupReturn<T> => {
  const persistedValues = sessionStorage.getItem(uid)

  return {
    clearBackup: () => {
      sessionStorage.removeItem(uid)
    },
    backup: (values) => {
      sessionStorage.setItem(uid, JSON.stringify(values))
    },
    initialValues: persistedValues ? JSON.parse(persistedValues) : undefined
  }
}
